"use strict"

angular.module("informaApp")
    .service("SavedSearchesCrossData", function () {
        this.data = null;
    });